import React, { useState, useEffect, useContext } from 'react';
import { MdPerson } from 'react-icons/md';
// import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { AuthContext } from '../context/AuthContext';
import { toast } from 'react-hot-toast';

const User = () => {
  const { authState } = useContext(AuthContext);
  // const navigate = useNavigate();
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/users`,
          {
            headers: { 'x-auth-token': authState.token }
          }
        );
        setUserData(response.data);
      } catch (error) {
        toast.error(error.response?.data?.message || 'Failed to fetch user profile');
      }
    };

    fetchUserProfile();
  }, [authState.token]);

  // const handleUpdateProfile = () => {
  //   navigate('/userprofile');
  // };

  return (
    <div className="flex items-center space-x-2 md:space-x-4">
      <div className="flex flex-col text-center items-center md:items-center">
        <div>
          <MdPerson size={20} />
        </div>
        <div className="text-xs md:text-md text-center md:text-left text-slate-100 font-semibold">{userData?.firstname} {userData?.lastname}</div>
        <div className="text-gray-600 text-xs md:text-sm truncate">{userData?.email}</div>
        {/* <button
          onClick={handleUpdateProfile}
          className="text-blue-500 hover:underline focus:outline-none text-xs md:text-sm mt-1"
          style={{
            boxShadow: "11px 13px 28px 3px rgba(0,0,0,0.75)", // Custom Box Shadow, adapted for subtlety
          }}
        >
          Update Profile
        </button> */}
      </div>
    </div>
  );
};

export default User;
